export const languageMapper = (countryCode: string) => {
  switch (countryCode) {
    case 'US':
    case 'EN':
      return 'en';
    default:
      return countryCode.toLowerCase();
  }
};
